<mat-form-field appearance="outline">
  <mat-label>Fabrikat filter</mat-label>
  <mat-chip-grid #fabrikatChipList aria-label="Fabrikater">
    <input
      placeholder="Vælg fabrikat..."
      #fabrikatInput
      [formControl]="fabrikatCtrl"
      [matAutocomplete]="fabrikatAuto"
      [matChipInputFor]="fabrikatChipList"
      />
      @for (fabrikat of selectedFabrikater; track fabrikat) {
        <mat-chip-row removable (removed)="removeFabrikat(fabrikat)">
          <span class="ellipsis" [matTooltip]="$safeNavigationMigration(fabrikat?.name)">{{ fabrikat?.name }} - {{ fabrikat?.produkt.text }}</span>
          <mat-icon matChipRemove matTooltip="Fjern fabrikat fra filter">cancel</mat-icon>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <mat-autocomplete #fabrikatAuto="matAutocomplete" (optionSelected)="fabrikatSelected($event)">
      @for (fabrikat of filteredFabrikater | async; track fabrikat) {
        <mat-option [value]="fabrikat">
          {{ fabrikat.name }} - {{ fabrikat.produkt.text }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
